import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10.5858 1.29051C11.3668 0.535851 12.6332 0.535854 13.4142 1.29051L21.4142 9.02025C21.7893 9.38265 22 9.87417 22 10.3867V20.6148C22 21.6821 21.1046 22.5473 20 22.5473H16C14.8954 22.5473 14 21.6821 14 20.6148V16.2669C14 15.1996 13.1046 14.3344 12 14.3344C10.8954 14.3344 10 15.1996 10 16.2669V20.6148C10 21.6821 9.10457 22.5473 8 22.5473H4C2.89543 22.5473 2 21.6821 2 20.6148V10.3867C2 9.87417 2.21071 9.38265 2.58579 9.02025L10.5858 1.29051ZM12 2.65695L4 10.3867V20.6148H8V16.2669C8 14.1324 9.79086 12.402 12 12.402C14.2091 12.402 16 14.1324 16 16.2669V20.6148H20V10.3867L12 2.65695Z",
			fill: "#444444"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 23.1892,
			fill: "white",
			transform: "translate(0 0.32431)"
		})
	}) })]
});
export default SvgHome;
